import React from 'react';
import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import { InsurancePicker } from './insurance-picker';

const updateModel =
  (onChange, model) =>
  ({ insuranceProvider, insureAmountOption, insureAmount }) => {
    const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
    const firstPackage = get(shippingConfiguration, 'packages.0', emptyObject);
    onChange({
      ...model,
      insureAmountOption,
      shippingConfiguration: {
        ...shippingConfiguration,
        insuranceProvider,
        packages: [
          {
            ...firstPackage,
            insuredValue: insureAmount,
          },
        ],
      },
    });
  };

const getInsuranceFromModel = (model) => {
  const { insureAmountOption } = model;
  const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
  const insuranceProvider = get(shippingConfiguration, 'insuranceProvider');
  const insureAmount = get(shippingConfiguration, 'packages.0.insuredValue', emptyObject);

  return {
    insuranceProvider,
    insureAmountOption,
    insureAmount,
  };
};

export const Insurance = {
  id: BulkActions.insurance.name,

  render: (onChange, model, jobData, isEmpty) => {
    const insurance = getInsuranceFromModel(model);
    const update = updateModel(onChange, model);
    return <InsurancePicker hasError={isEmpty} insurance={insurance} onChange={update} />;
  },
};
